export enum FilterType {
  Contains = 0,
  Equal = 1,
  NotEqual = 2,
  GreaterThan = 3,
  LessThan = 4,
  GreaterThanOrEqual = 5,
  LessThanOrEqual = 6,
  StartsWith = 7,
  MultipleContains = 8,
  HasFlag = 9,
  HasNoFlag = 10
}
